import { useCallback } from 'react';
import { NavigateOptions, To, useLocation, useNavigate as useBaseNavigate } from 'react-router-dom';

import useResolveTo, { ResolveToOptions } from './useResolveTo.js';

export interface NavigateFunction {
  (to: To, options?: NavigateOptions & ResolveToOptions): void;
  (delta: number): void;
}

/**
 * Wrapped version of react-router-dom's useNavigate component that
 * resolves the `to` prop with search and language.
 */
export const useNavigate = () => {
  const navigate = useBaseNavigate();
  const resolveTo = useResolveTo();
  const previous = useLocation();

  return useCallback<NavigateFunction>(
    (...args: any[]) => {
      const [to, opts] = args;
      if (typeof to === 'number') {
        return navigate(to);
      }

      const { keepSearchParams, lang, ...restOpts } = opts || {};
      return navigate(resolveTo(to, { keepSearchParams, lang }), {
        ...restOpts,
        state: {
          ...restOpts?.state,
          previous,
        },
      });
    },
    [navigate, previous, resolveTo]
  );
};

export default useNavigate;
